module.exports = __webpack_public_path__ + "img/slide10.473c48ae.png";